import actions from '@cms/i18n/locale/nl_NL/actions.json';
import admin from '@cms/i18n/locale/nl_NL/admin.json';
import ads from '@cms/i18n/locale/nl_NL/ads.json';
import adsTxt from '@cms/i18n/locale/nl_NL/ads-txt.json';
import aiPrompts from '@cms/i18n/locale/nl_NL/ai-prompts.json';
import aiResults from '@cms/i18n/locale/nl_NL/ai-results.json';
import articles from '@cms/i18n/locale/nl_NL/articles.json';
import auditLogs from '@cms/i18n/locale/nl_NL/audit-logs.json';
import blockedDomain from '@cms/i18n/locale/nl_NL/blocked-domain.json';
import blockedIps from '@cms/i18n/locale/nl_NL/blocked-ips.json';
import comments from '@cms/i18n/locale/nl_NL/comments.json';
import common from '@cms/i18n/locale/nl_NL/common.json';
import components from '@cms/i18n/locale/nl_NL/components.json';
import config from '@cms/i18n/locale/nl_NL/config.json';
import curation from '@cms/i18n/locale/nl_NL/curation.json';
import datetime from '@cms/i18n/locale/nl_NL/datetime.json';
import events from '@cms/i18n/locale/nl_NL/events.json';
import experiments from '@cms/i18n/locale/nl_NL/experiments.json';
import faqCategories from '@cms/i18n/locale/nl_NL/faqCategories.json';
import faqs from '@cms/i18n/locale/nl_NL/faqs.json';
import filteredComments from '@cms/i18n/locale/nl_NL/filtered-comments.json';
import forbiddenWords from '@cms/i18n/locale/nl_NL/forbidden-words.json';
import ipQs from '@cms/i18n/locale/nl_NL/ip-qs.json';
import matchReports from '@cms/i18n/locale/nl_NL/match-reports.json';
import matchTicker from '@cms/i18n/locale/nl_NL/match-ticker.json';
import meta from '@cms/i18n/locale/nl_NL/meta.json';
import moduleSchedule from '@cms/i18n/locale/nl_NL/module-schedule.json';
import navItems from '@cms/i18n/locale/nl_NL/nav-items.json';
import newsCategory from '@cms/i18n/locale/nl_NL/news-category.json';
import notificationbar from '@cms/i18n/locale/nl_NL/notificationbar.json';
import oddsdossier from '@cms/i18n/locale/nl_NL/oddsdossier.json';
import optaExports from '@cms/i18n/locale/nl_NL/opta-exports.json';
import pages from '@cms/i18n/locale/nl_NL/pages.json';
import partner from '@cms/i18n/locale/nl_NL/partner.json';
import poll from '@cms/i18n/locale/nl_NL/poll.json';
import propositions from '@cms/i18n/locale/nl_NL/propositions.json';
import recaptcha from '@cms/i18n/locale/nl_NL/recaptcha.json';
import redirects from '@cms/i18n/locale/nl_NL/redirects.json';
import richEditor from '@cms/i18n/locale/nl_NL/rich-editor.json';
import sandbox from '@cms/i18n/locale/nl_NL/sandbox.json';
import standing from '@cms/i18n/locale/nl_NL/standing.json';
import stats from '@cms/i18n/locale/nl_NL/stats.json';
import subscribe from '@cms/i18n/locale/nl_NL/subscribe.json';
import subscriptionGifts from '@cms/i18n/locale/nl_NL/subscription-gifts.json';
import tags from '@cms/i18n/locale/nl_NL/tags.json';
import tierGroups from '@cms/i18n/locale/nl_NL/tier-groups.json';
import tiers from '@cms/i18n/locale/nl_NL/tiers.json';
import url from '@cms/i18n/locale/nl_NL/url.json';
import user from '@cms/i18n/locale/nl_NL/user.json';
import videofeed from '@cms/i18n/locale/nl_NL/videofeed.json';

import { Ns } from './types';

export const I18N_RESOURCES: Record<Ns, any> = {
    [Ns.Actions]: actions,
    [Ns.Admin]: admin,
    [Ns.AdsTxt]: adsTxt,
    [Ns.Ads]: ads,
    [Ns.AiPrompts]: aiPrompts,
    [Ns.AiResults]: aiResults,
    [Ns.Articles]: articles,
    [Ns.AuditLogs]: auditLogs,
    [Ns.BlockedDomain]: blockedDomain,
    [Ns.BlockedIps]: blockedIps,
    [Ns.Comments]: comments,
    [Ns.Common]: common,
    [Ns.Components]: components,
    [Ns.Config]: config,
    [Ns.Curation]: curation,
    [Ns.Datetime]: datetime,
    [Ns.Events]: events,
    [Ns.Experiments]: experiments,
    [Ns.FaqCategories]: faqCategories,
    [Ns.Faqs]: faqs,
    [Ns.FilteredComments]: filteredComments,
    [Ns.ForbiddenWords]: forbiddenWords,
    [Ns.IpQs]: ipQs,
    [Ns.MatchReports]: matchReports,
    [Ns.MatchTicker]: matchTicker,
    [Ns.Meta]: meta,
    [Ns.ModuleSchedule]: moduleSchedule,
    [Ns.NavItems]: navItems,
    [Ns.NewsCategory]: newsCategory,
    [Ns.Notificationbar]: notificationbar,
    [Ns.Oddsdossier]: oddsdossier,
    [Ns.OptaExports]: optaExports,
    [Ns.Pages]: pages,
    [Ns.Partner]: partner,
    [Ns.Poll]: poll,
    [Ns.Propositions]: propositions,
    [Ns.Recaptcha]: recaptcha,
    [Ns.Redirects]: redirects,
    [Ns.RichEditor]: richEditor,
    [Ns.Sandbox]: sandbox,
    [Ns.Standing]: standing,
    [Ns.Stats]: stats,
    [Ns.Subscribe]: subscribe,
    [Ns.SubscriptionGifts]: subscriptionGifts,
    [Ns.Tags]: tags,
    [Ns.TierGroups]: tierGroups,
    [Ns.Tiers]: tiers,
    [Ns.Url]: url,
    [Ns.User]: user,
    [Ns.Videofeed]: videofeed,
};
